import { DeliveryIconComponent, ReserveIcon } from "../../../../../../../../Components/IconComponents";
import PackageIcon from "../../../../../../../../Components/IconComponents/packageIcon";
import useLanguagesHooks from "../../../../../../../../Components/Languages/setLanguage-hooks";
import { IDeliveryOrderData, IOrderParams, IPreOrderData, IReserveOrderData, OrderTypes } from "../../../../../../../../Interfaces/componentTypes";
import { formatDate, formatTime } from "../../../../../../../../Utilits/utilits";
import styles from './companyOrderCard.module.scss';

interface CompanyOrderCardContent {
  icon: JSX.Element;
  typeLabel: string;
  extraFields: JSX.Element[];
}

const useCompanyOrderCards = (currencySymbol: string, isNew?: boolean,) => {
  const { t } = useLanguagesHooks();

  function getOrderCardContent(
    order_type: OrderTypes,
    order_parameters: IOrderParams,
    data: string
  ): CompanyOrderCardContent {
    let parsedData: IDeliveryOrderData | IPreOrderData | IReserveOrderData;

    try {
      parsedData = JSON.parse(data);
    } catch {
      parsedData = {} as any;
    }

    switch (order_type) {
      case OrderTypes.DELIVERY:
        return {
          icon: <DeliveryIconComponent width={40} height={40} />,
          typeLabel: t('Visitor.My_Order_Card.Delivery'),
          extraFields: [
            <p className={isNew ? styles.fieldLableNew : styles.fieldLable} key="items">{t('Visitor.My_Order_Card.Items')}
              <span className={isNew ? styles.fieldValueNew : styles.fieldValue}>{order_parameters.totalItems}</span></p>,
            <p className={isNew ? styles.fieldLableNew : styles.fieldLable} key="delivery">{t('Visitor.My_Order_Card.Delivery_Fee')}
              <span className={isNew ? styles.fieldValueNew : styles.fieldValue}>{(parsedData as IDeliveryOrderData).delivery_cost} {currencySymbol}</span></p>,
            <p className={isNew ? styles.fieldLableNew : styles.fieldLable} key="cost">{t('Visitor.Total')}
              <span className={isNew ? styles.fieldValueNew : styles.fieldValue} style={{ marginLeft: '5px' }}>{parsedData.total_cost} {currencySymbol}</span> </p>,
          ],
        };

      case OrderTypes.PREORDER:
        return {
          icon: <PackageIcon width={40} height={40} />,
          typeLabel: t('Visitor.My_Order_Card.Pre_Order'),
          extraFields: [
            <p className={isNew ? styles.fieldLableNew : styles.fieldLable} key="items">{t('Visitor.My_Order_Card.Items')}
              <span className={isNew ? styles.fieldValueNew : styles.fieldValue}>{order_parameters.totalItems}</span></p>,
            <p className={isNew ? styles.fieldLableNew : styles.fieldLable} key="cost">  {t('Visitor.Total')}
              <span className={isNew ? styles.fieldValueNew : styles.fieldValue} style={{ marginLeft: '5px' }}>{parsedData.total_cost} {currencySymbol}</span> </p>,
          ],
        };

      case OrderTypes.RESERVE:
        return {
          icon: <ReserveIcon width={40} height={40} />,
          typeLabel: t('Visitor.My_Order_Card.Reserve'),
          extraFields: [
            <p className={isNew ? styles.fieldLableNew : styles.fieldLable} key="persons">{t('Visitor.Reserve.Persons')}: {order_parameters.persons_count}</p>,
            <p className={isNew ? styles.fieldLableNew : styles.fieldLable} key="items">{t("Visitor.My_Order_Card.Date")}
              <span className={isNew ? styles.fieldValueNew : styles.fieldValue}> {formatDate(order_parameters.date!, false)} {formatTime(order_parameters.time!)}</span></p>,
            order_parameters.totalItems ?
              <p className={isNew ? styles.fieldLableNew : styles.fieldLable} key="items">{t('Visitor.My_Order_Card.Items')}
                <span className={isNew ? styles.fieldValueNew : styles.fieldValue}>{order_parameters.totalItems}</span></p>
              :
              <div />,
            parsedData.total_cost
              ?
              < p className={isNew ? styles.fieldLableNew : styles.fieldLable} key="cost" > {t('Visitor.Total')}
                < span className={isNew ? styles.fieldValueNew : styles.fieldValue} style={{ marginLeft: '4px' }} > {parsedData.total_cost}</span > {currencySymbol}</p >
              :
              <div />,
          ],
        };

      default:
        return {
          icon: <></>,
          typeLabel: "Unknown Order",
          extraFields: [],
        };
    }
  };

  return {
    getOrderCardContent,
  };
};

export default useCompanyOrderCards;
